module.exports = __webpack_public_path__ + "assets/img/title.d0c3f066.png";